import { combineReducers } from 'redux';
import { i18nReducer } from 'react-redux-i18n';
import { reducer as formReducer } from 'redux-form';
import imsReducer from '../components/AdobeIMS/reducers/imsReducer';
import errorReducer from './errorReducer';
import adminReducer from './adminReducer';
import companyReducer from './companyReducer';
import commonReducer from './commonReducer';
import registrationReducer from '../registration/storeManagement/reducer';
import uplevelRenewalReducer from '../uplevel_renewal/storeManagement/reducer';
import specializationReducer from '../specialization/storeManagement/reducer';

export default combineReducers({
  i18n: i18nReducer,
  ims: imsReducer,
  form: formReducer,
  errors: errorReducer,
  admin: adminReducer,
  company: companyReducer,
  registration: registrationReducer,
  common : commonReducer,
  uplevelRenewal: uplevelRenewalReducer,
  specialization: specializationReducer
});
